import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { themeSpinner } from './theme.js';
import { iconSize } from '../../foundations/__generated__/size.js';
const Spinner = ({ size = "medium", theme }) => {
    const mergedTheme = { ...themeSpinner, ...theme };
    const spinnerWidth = typeof size === "number" ? size : iconSize[size];
    return /* @__PURE__ */ jsx("svg", {
        width: spinnerWidth,
        viewBox: "0 0 30 30",
        focusable: false,
        "aria-hidden": true,
        children: /* @__PURE__ */ jsxs("g", { children: [
                /* @__PURE__ */ jsx("animateTransform", {
                    attributeName: "transform",
                    attributeType: "XML",
                    type: "rotate",
                    from: "0 15 15",
                    to: "360 15 15",
                    dur: "2.5s",
                    repeatCount: "indefinite"
                }),
                /* @__PURE__ */ jsx("circle", {
                    cx: 15,
                    cy: 15,
                    r: 12.5,
                    strokeWidth: 5,
                    stroke: mergedTheme.background,
                    fill: "transparent"
                }),
                /* @__PURE__ */ jsx("circle", {
                    cx: 15,
                    cy: 15,
                    r: 12.5,
                    strokeWidth: 5,
                    strokeDasharray: 82,
                    strokeDashoffset: 82,
                    stroke: mergedTheme.color,
                    fill: "transparent",
                    children: /* @__PURE__ */ jsx("animate", {
                        attributeName: "stroke-dashoffset",
                        dur: "3.5s",
                        from: 164,
                        to: 0,
                        repeatCount: "indefinite"
                    })
                })
            ] })
    });
};
export { Spinner };
